import { api, unwrap, toPaginated, cleanParams } from "../lib/axios";
import type { ApiEnvelope, ListParams, PaginatedResult } from "../types/api";
import type { Coupon } from "../types/domain";

export const couponsApi = {
  async list(
    params: ListParams & { isActive?: boolean },
  ): Promise<PaginatedResult<Coupon>> {
    const res = await api.get<ApiEnvelope<unknown>>("/coupon", {
      params: cleanParams(params),
    });
    return toPaginated<Coupon>(res, "coupons");
  },

  async get(id: string): Promise<Coupon> {
    const res = await api.get<ApiEnvelope<Coupon>>(`/coupon/${id}`);
    return unwrap(res);
  },

  async create(body: Partial<Coupon>): Promise<Coupon> {
    const res = await api.post<ApiEnvelope<Coupon>>("/coupon", body);
    return unwrap(res);
  },

  async update(id: string, body: Partial<Coupon>): Promise<Coupon> {
    const res = await api.patch<ApiEnvelope<Coupon>>(`/coupon/${id}`, body);
    return unwrap(res);
  },

  async toggleStatus(id: string): Promise<Coupon> {
    const res = await api.patch<ApiEnvelope<Coupon>>(
      `/coupon/${id}/toggle-status`,
    );
    return unwrap(res);
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/coupon/${id}`);
  },

  async usageStats(id: string): Promise<Record<string, unknown>> {
    const res = await api.get<ApiEnvelope<Record<string, unknown>>>(
      `/coupon/${id}/usage-stats`,
    );
    return unwrap(res);
  },
};
